// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.why-votesee {
    align-items: flex-start;
    background-color: var(--semantic-background-color-primary);
    display: flex;
    flex-direction: column;
    gap: 84px;
    padding: 58px 68px 52px;
    position: relative;
    width: 1512px;
}

.why-votesee .container {
    align-items: flex-start; /* Ensure everything aligns to the left by default */
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    gap: 84px;
    position: relative;
    width: 100%;
}

.why-votesee .content {
    align-items: stretch; /* Allow individual elements to control their alignment */
    display: flex;
    flex: 1 1;
    flex-direction: column;
    gap: 25.2px;
    position: relative;
    width: 100%;
}

.why-votesee .div {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 33.6px;
    position: relative;
    width: 100%;
}

.why-votesee .section-title {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 16.8px;
    position: relative;
    width: 100%;
}

.why-votesee .content-2 {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 25.2px;
    position: relative;
    width: 100%;
}

.why-votesee .heading {
    align-self: stretch;
    color: var(--semantic-text-primary);
    font-family: var(--h-2-font-family);
    font-size: var(--h-2-font-size);
    font-style: var(--h-2-font-style);
    font-weight: var(--h-2-font-weight);
    letter-spacing: var(--h-2-letter-spacing);
    line-height: var(--h-2-line-height);
    margin-top: -1.05px;
    position: relative;
}

.why-votesee .span {
    color: #000000;
    font-family: var(--h-2-font-family);
    font-size: var(--h-2-font-size);
    font-style: var(--h-2-font-style);
    font-weight: var(--h-2-font-weight);
    letter-spacing: var(--h-2-letter-spacing);
    line-height: var(--h-2-line-height);
}

.why-votesee .text-wrapper-2 {
    color: #458BEA;
    font-family: var(--h-2-font-family);
    font-size: var(--h-2-font-size);
    font-style: var(--h-2-font-style);
    font-weight: var(--h-2-font-weight);
    letter-spacing: var(--h-2-letter-spacing);
    line-height: var(--h-2-line-height);
}

.why-votesee .text {
    align-self: stretch;
    color: var(--semantic-text-primary);
    font-family: var(--p-font-family);
    font-size: var(--p-font-size);
    font-style: var(--p-font-style);
    font-weight: var(--p-font-weight);
    letter-spacing: var(--p-letter-spacing);
    line-height: var(--p-line-height);
    position: relative;
}

.why-votesee .list {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 16.8px;
    padding: 8.4px 0px;
    position: relative;
    width: 100%;
}

.why-votesee .list-item {
    align-items: center;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    gap: 16.8px;
    position: relative;
    width: 100%;
}

.why-votesee .text-wrapper-3 {
    color: #458BEA;
    font-family: "Material Icons-Regular", Helvetica;
    font-size: 16.8px;
    font-weight: 400;
    height: 24px;
    letter-spacing: 0;
    line-height: normal;
    position: relative;
    text-align: center;
    width: 24px;
}

.why-votesee .lorem-ipsum-dolor {
    color: var(--primitive-black);
    flex: 1 1;
    font-family: var(--small-font-family);
    font-size: var(--small-font-size);
    font-style: var(--small-font-style);
    font-weight: var(--small-font-weight);
    letter-spacing: var(--small-letter-spacing);
    line-height: var(--small-line-height);
    margin-top: -1.05px;
    position: relative;
    color: var(--black, #000);
    font-size: 16.8px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 25.2px */
}

.why-votesee .button-instance {
    border-radius: 6px !important;

    width: auto; /* Keep the button's width based on its content */
    align-self: flex-start; /* Align the button to the left within its container */
}

.why-votesee .mask-group {
    height: 582px;
    position: relative;
    width: 658px;
}

.why-votesee .mobile-image {
    display: none;
}
.why-votesee .button-container {
    align-self: flex-start;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    padding-left: 20px;
}

@media (max-width: 1224px) {
    .why-votesee {
        padding: 40px 20px; /* Adjust padding for smaller screens */
        width: 100%; /* Ensure the container takes full width */
        gap: 40px; /* Adjust gap between elements */
    }

    .why-votesee .container {
        flex-direction: column;
        align-items: center; /* Center children horizontally */
        gap: 30px; /* Adjust gap between container items */
        width: 100%; /* Ensure container takes full width */
    }

    .why-votesee .mobile-image {
        display: flex;
        width: 100%; /* Ensure it takes full width */
        height: auto; /* Maintain aspect ratio */
        flex-shrink: 0;
        justify-content: center; /* Center content horizontally */
        align-items: center; /* Center content vertically */
        margin: auto; /* Auto margin for additional centering */
    }

    .why-votesee .mask-group {
        display: none !important;
    }

    .why-votesee .content {
        order: 1; /* Ensure content appears after mask-group */
        align-items: center; /* Center content horizontally */
        width: 100%; /* Ensure content takes full width */
        height: auto; /* Allow content to grow in height */
    }

    .why-votesee .div {
        padding: 0 20px; /* Adjust padding for smaller screens */
        align-items: center; /* Center content horizontally */
        width: 100%; /* Ensure div takes full width */
        height: auto; /* Allow div to grow in height */
    }

    .why-votesee .section-title {
        justify-content: center; /* Center content horizontally */
        align-items: center; /* Center content vertically */
        text-align: center; /* Center text within the flex container */
        width: 100%; /* Ensure the section-title takes up the full width */
        height: auto; /* Adjust height as needed */
    }

    .why-votesee .list {
        padding: 0 0px; /* Adjust padding */
        flex-direction: column;
        align-items: flex-start;
        gap: 10px; /* Adjust gap between list items */
        width: 100%; /* Ensure list takes full width */
        height: auto; /* Allow list to grow in height */
    }

    .why-votesee .heading {
        font-size: 18px; /* Adjust font size for mobile */
        text-align: center; /* Center text */
        width: 100%; /* Ensure heading takes full width */
    }

    .why-votesee .text {
        text-align: left; /* Align text to the left */
        font-size: 16px; /* Adjust font size */
        line-height: 24px; /* Adjust line height */
        width: 100%; /* Ensure text takes full width */
        height: auto; /* Allow text to grow in height */
    }

    .why-votesee .lorem-ipsum-dolor {
        font-size: 14px; /* Adjust font size for mobile */
        line-height: 21px; /* Adjust line height for mobile */
        width: 100%; /* Ensure lorem-ipsum-dolor takes full width */
        height: auto; /* Allow lorem-ipsum-dolor to grow in height */
    }

    .why-votesee .button-instance {

        width: auto; /* Ensure button width is determined by content */
        align-self: flex-start; /* Keep the button aligned to the left */
    }
}

@media (max-width: 400px) {
    .why-votesee {
        padding: 30px 10px; /* Adjust padding for very small screens */
        width: 100%; /* Ensure container takes full width */
        gap: 20px; /* Reduce gap between elements */
    }

    .why-votesee .container {
        flex-direction: column;
        align-items: center; /* Center children horizontally */
        gap: 20px; /* Adjust gap between container items */
        width: 100%; /* Ensure container takes full width */
    }

    .why-votesee .mobile-image {
        width: 100%; /* Ensure it takes full width */
        height: auto; /* Maintain aspect ratio */
    }

    .why-votesee .mask-group {
        display: none !important;
    }

    .why-votesee .content {
        width: 100%; /* Ensure content takes full width */
    }

    .why-votesee .div {
        padding: 0 10px; /* Adjust padding for very small screens */
        width: 100%; /* Ensure div takes full width */
    }

    .why-votesee .section-title {
        width: 100%; /* Ensure section-title takes full width */
    }

    .why-votesee .list {
        padding: 0 0px; /* Adjust padding */
        gap: 8px; /* Adjust gap between list items */
        width: 100%; /* Ensure list takes full width */
    }

    .why-votesee .heading {
        font-size: 16px; /* Adjust font size for smaller screens */
    }

    .why-votesee .text {
        font-size: 14px; /* Adjust font size */
        line-height: 20px; /* Adjust line height */
        width: 100%; /* Ensure text takes full width */
    }

    .why-votesee .lorem-ipsum-dolor {
        font-size: 12px; /* Adjust font size for very small screens */
        line-height: 18px; /* Adjust line height */
    }

    .why-votesee .button-instance {
        padding: 8px 12px; /* Adjust padding for smaller screens */
        width: auto; /* Ensure button width is determined by content */
        align-self: flex-start; /* Keep the button aligned to the left */
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/WhyVotesee/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,0DAA0D;IAC1D,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,uBAAuB,EAAE,oDAAoD;IAC7E,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,oBAAoB,EAAE,yDAAyD;IAC/E,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,mCAAmC;IACnC,+BAA+B;IAC/B,iCAAiC;IACjC,mCAAmC;IACnC,yCAAyC;IACzC,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,+BAA+B;IAC/B,iCAAiC;IACjC,mCAAmC;IACnC,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,+BAA+B;IAC/B,iCAAiC;IACjC,mCAAmC;IACnC,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,iCAAiC;IACjC,6BAA6B;IAC7B,+BAA+B;IAC/B,iCAAiC;IACjC,uCAAuC;IACvC,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gDAAgD;IAChD,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,SAAO;IACP,qCAAqC;IACrC,iCAAiC;IACjC,mCAAmC;IACnC,qCAAqC;IACrC,2CAA2C;IAC3C,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;AAClC;;AAEA;IACI,6BAA6B;;IAE7B,WAAW,EAAE,iDAAiD;IAC9D,sBAAsB,EAAE,sDAAsD;AAClF;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB,EAAE,uCAAuC;QAC3D,WAAW,EAAE,0CAA0C;QACvD,SAAS,EAAE,gCAAgC;IAC/C;;IAEA;QACI,sBAAsB;QACtB,mBAAmB,EAAE,iCAAiC;QACtD,SAAS,EAAE,uCAAuC;QAClD,WAAW,EAAE,sCAAsC;IACvD;;IAEA;QACI,aAAa;QACb,WAAW,EAAE,+BAA+B;QAC5C,YAAY,EAAE,0BAA0B;QACxC,cAAc;QACd,uBAAuB,EAAE,gCAAgC;QACzD,mBAAmB,EAAE,8BAA8B;QACnD,YAAY,EAAE,yCAAyC;IAC3D;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,QAAQ,EAAE,4CAA4C;QACtD,mBAAmB,EAAE,gCAAgC;QACrD,WAAW,EAAE,oCAAoC;QACjD,YAAY,EAAE,oCAAoC;IACtD;;IAEA;QACI,eAAe,EAAE,uCAAuC;QACxD,mBAAmB,EAAE,gCAAgC;QACrD,WAAW,EAAE,gCAAgC;QAC7C,YAAY,EAAE,gCAAgC;IAClD;;IAEA;QACI,uBAAuB,EAAE,gCAAgC;QACzD,mBAAmB,EAAE,8BAA8B;QACnD,kBAAkB,EAAE,0CAA0C;QAC9D,WAAW,EAAE,qDAAqD;QAClE,YAAY,EAAE,4BAA4B;IAC9C;;IAEA;QACI,cAAc,EAAE,mBAAmB;QACnC,sBAAsB;QACtB,uBAAuB;QACvB,SAAS,EAAE,kCAAkC;QAC7C,WAAW,EAAE,iCAAiC;QAC9C,YAAY,EAAE,iCAAiC;IACnD;;IAEA;QACI,eAAe,EAAE,gCAAgC;QACjD,kBAAkB,EAAE,gBAAgB;QACpC,WAAW,EAAE,oCAAoC;IACrD;;IAEA;QACI,gBAAgB,EAAE,2BAA2B;QAC7C,eAAe,EAAE,qBAAqB;QACtC,iBAAiB,EAAE,uBAAuB;QAC1C,WAAW,EAAE,iCAAiC;QAC9C,YAAY,EAAE,iCAAiC;IACnD;;IAEA;QACI,eAAe,EAAE,gCAAgC;QACjD,iBAAiB,EAAE,kCAAkC;QACrD,WAAW,EAAE,8CAA8C;QAC3D,YAAY,EAAE,8CAA8C;IAChE;;IAEA;;QAEI,WAAW,EAAE,iDAAiD;QAC9D,sBAAsB,EAAE,wCAAwC;IACpE;AACJ;;AAEA;IACI;QACI,kBAAkB,EAAE,0CAA0C;QAC9D,WAAW,EAAE,sCAAsC;QACnD,SAAS,EAAE,gCAAgC;IAC/C;;IAEA;QACI,sBAAsB;QACtB,mBAAmB,EAAE,iCAAiC;QACtD,SAAS,EAAE,uCAAuC;QAClD,WAAW,EAAE,sCAAsC;IACvD;;IAEA;QACI,WAAW,EAAE,+BAA+B;QAC5C,YAAY,EAAE,0BAA0B;IAC5C;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW,EAAE,oCAAoC;IACrD;;IAEA;QACI,eAAe,EAAE,0CAA0C;QAC3D,WAAW,EAAE,gCAAgC;IACjD;;IAEA;QACI,WAAW,EAAE,0CAA0C;IAC3D;;IAEA;QACI,cAAc,EAAE,mBAAmB;QACnC,QAAQ,EAAE,kCAAkC;QAC5C,WAAW,EAAE,iCAAiC;IAClD;;IAEA;QACI,eAAe,EAAE,yCAAyC;IAC9D;;IAEA;QACI,eAAe,EAAE,qBAAqB;QACtC,iBAAiB,EAAE,uBAAuB;QAC1C,WAAW,EAAE,iCAAiC;IAClD;;IAEA;QACI,eAAe,EAAE,4CAA4C;QAC7D,iBAAiB,EAAE,uBAAuB;IAC9C;;IAEA;QACI,iBAAiB,EAAE,uCAAuC;QAC1D,WAAW,EAAE,iDAAiD;QAC9D,sBAAsB,EAAE,wCAAwC;IACpE;AACJ","sourcesContent":[".why-votesee {\n    align-items: flex-start;\n    background-color: var(--semantic-background-color-primary);\n    display: flex;\n    flex-direction: column;\n    gap: 84px;\n    padding: 58px 68px 52px;\n    position: relative;\n    width: 1512px;\n}\n\n.why-votesee .container {\n    align-items: flex-start; /* Ensure everything aligns to the left by default */\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    gap: 84px;\n    position: relative;\n    width: 100%;\n}\n\n.why-votesee .content {\n    align-items: stretch; /* Allow individual elements to control their alignment */\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    gap: 25.2px;\n    position: relative;\n    width: 100%;\n}\n\n.why-votesee .div {\n    align-items: flex-start;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 33.6px;\n    position: relative;\n    width: 100%;\n}\n\n.why-votesee .section-title {\n    align-items: flex-start;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 16.8px;\n    position: relative;\n    width: 100%;\n}\n\n.why-votesee .content-2 {\n    align-items: flex-start;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 25.2px;\n    position: relative;\n    width: 100%;\n}\n\n.why-votesee .heading {\n    align-self: stretch;\n    color: var(--semantic-text-primary);\n    font-family: var(--h-2-font-family);\n    font-size: var(--h-2-font-size);\n    font-style: var(--h-2-font-style);\n    font-weight: var(--h-2-font-weight);\n    letter-spacing: var(--h-2-letter-spacing);\n    line-height: var(--h-2-line-height);\n    margin-top: -1.05px;\n    position: relative;\n}\n\n.why-votesee .span {\n    color: #000000;\n    font-family: var(--h-2-font-family);\n    font-size: var(--h-2-font-size);\n    font-style: var(--h-2-font-style);\n    font-weight: var(--h-2-font-weight);\n    letter-spacing: var(--h-2-letter-spacing);\n    line-height: var(--h-2-line-height);\n}\n\n.why-votesee .text-wrapper-2 {\n    color: #458BEA;\n    font-family: var(--h-2-font-family);\n    font-size: var(--h-2-font-size);\n    font-style: var(--h-2-font-style);\n    font-weight: var(--h-2-font-weight);\n    letter-spacing: var(--h-2-letter-spacing);\n    line-height: var(--h-2-line-height);\n}\n\n.why-votesee .text {\n    align-self: stretch;\n    color: var(--semantic-text-primary);\n    font-family: var(--p-font-family);\n    font-size: var(--p-font-size);\n    font-style: var(--p-font-style);\n    font-weight: var(--p-font-weight);\n    letter-spacing: var(--p-letter-spacing);\n    line-height: var(--p-line-height);\n    position: relative;\n}\n\n.why-votesee .list {\n    align-items: flex-start;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 16.8px;\n    padding: 8.4px 0px;\n    position: relative;\n    width: 100%;\n}\n\n.why-votesee .list-item {\n    align-items: center;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    gap: 16.8px;\n    position: relative;\n    width: 100%;\n}\n\n.why-votesee .text-wrapper-3 {\n    color: #458BEA;\n    font-family: \"Material Icons-Regular\", Helvetica;\n    font-size: 16.8px;\n    font-weight: 400;\n    height: 24px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: relative;\n    text-align: center;\n    width: 24px;\n}\n\n.why-votesee .lorem-ipsum-dolor {\n    color: var(--primitive-black);\n    flex: 1;\n    font-family: var(--small-font-family);\n    font-size: var(--small-font-size);\n    font-style: var(--small-font-style);\n    font-weight: var(--small-font-weight);\n    letter-spacing: var(--small-letter-spacing);\n    line-height: var(--small-line-height);\n    margin-top: -1.05px;\n    position: relative;\n    color: var(--black, #000);\n    font-size: 16.8px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 25.2px */\n}\n\n.why-votesee .button-instance {\n    border-radius: 6px !important;\n\n    width: auto; /* Keep the button's width based on its content */\n    align-self: flex-start; /* Align the button to the left within its container */\n}\n\n.why-votesee .mask-group {\n    height: 582px;\n    position: relative;\n    width: 658px;\n}\n\n.why-votesee .mobile-image {\n    display: none;\n}\n.why-votesee .button-container {\n    align-self: flex-start;\n    display: flex;\n    justify-content: flex-start;\n    width: 100%;\n    padding-left: 20px;\n}\n\n@media (max-width: 1224px) {\n    .why-votesee {\n        padding: 40px 20px; /* Adjust padding for smaller screens */\n        width: 100%; /* Ensure the container takes full width */\n        gap: 40px; /* Adjust gap between elements */\n    }\n\n    .why-votesee .container {\n        flex-direction: column;\n        align-items: center; /* Center children horizontally */\n        gap: 30px; /* Adjust gap between container items */\n        width: 100%; /* Ensure container takes full width */\n    }\n\n    .why-votesee .mobile-image {\n        display: flex;\n        width: 100%; /* Ensure it takes full width */\n        height: auto; /* Maintain aspect ratio */\n        flex-shrink: 0;\n        justify-content: center; /* Center content horizontally */\n        align-items: center; /* Center content vertically */\n        margin: auto; /* Auto margin for additional centering */\n    }\n\n    .why-votesee .mask-group {\n        display: none !important;\n    }\n\n    .why-votesee .content {\n        order: 1; /* Ensure content appears after mask-group */\n        align-items: center; /* Center content horizontally */\n        width: 100%; /* Ensure content takes full width */\n        height: auto; /* Allow content to grow in height */\n    }\n\n    .why-votesee .div {\n        padding: 0 20px; /* Adjust padding for smaller screens */\n        align-items: center; /* Center content horizontally */\n        width: 100%; /* Ensure div takes full width */\n        height: auto; /* Allow div to grow in height */\n    }\n\n    .why-votesee .section-title {\n        justify-content: center; /* Center content horizontally */\n        align-items: center; /* Center content vertically */\n        text-align: center; /* Center text within the flex container */\n        width: 100%; /* Ensure the section-title takes up the full width */\n        height: auto; /* Adjust height as needed */\n    }\n\n    .why-votesee .list {\n        padding: 0 0px; /* Adjust padding */\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px; /* Adjust gap between list items */\n        width: 100%; /* Ensure list takes full width */\n        height: auto; /* Allow list to grow in height */\n    }\n\n    .why-votesee .heading {\n        font-size: 18px; /* Adjust font size for mobile */\n        text-align: center; /* Center text */\n        width: 100%; /* Ensure heading takes full width */\n    }\n\n    .why-votesee .text {\n        text-align: left; /* Align text to the left */\n        font-size: 16px; /* Adjust font size */\n        line-height: 24px; /* Adjust line height */\n        width: 100%; /* Ensure text takes full width */\n        height: auto; /* Allow text to grow in height */\n    }\n\n    .why-votesee .lorem-ipsum-dolor {\n        font-size: 14px; /* Adjust font size for mobile */\n        line-height: 21px; /* Adjust line height for mobile */\n        width: 100%; /* Ensure lorem-ipsum-dolor takes full width */\n        height: auto; /* Allow lorem-ipsum-dolor to grow in height */\n    }\n\n    .why-votesee .button-instance {\n\n        width: auto; /* Ensure button width is determined by content */\n        align-self: flex-start; /* Keep the button aligned to the left */\n    }\n}\n\n@media (max-width: 400px) {\n    .why-votesee {\n        padding: 30px 10px; /* Adjust padding for very small screens */\n        width: 100%; /* Ensure container takes full width */\n        gap: 20px; /* Reduce gap between elements */\n    }\n\n    .why-votesee .container {\n        flex-direction: column;\n        align-items: center; /* Center children horizontally */\n        gap: 20px; /* Adjust gap between container items */\n        width: 100%; /* Ensure container takes full width */\n    }\n\n    .why-votesee .mobile-image {\n        width: 100%; /* Ensure it takes full width */\n        height: auto; /* Maintain aspect ratio */\n    }\n\n    .why-votesee .mask-group {\n        display: none !important;\n    }\n\n    .why-votesee .content {\n        width: 100%; /* Ensure content takes full width */\n    }\n\n    .why-votesee .div {\n        padding: 0 10px; /* Adjust padding for very small screens */\n        width: 100%; /* Ensure div takes full width */\n    }\n\n    .why-votesee .section-title {\n        width: 100%; /* Ensure section-title takes full width */\n    }\n\n    .why-votesee .list {\n        padding: 0 0px; /* Adjust padding */\n        gap: 8px; /* Adjust gap between list items */\n        width: 100%; /* Ensure list takes full width */\n    }\n\n    .why-votesee .heading {\n        font-size: 16px; /* Adjust font size for smaller screens */\n    }\n\n    .why-votesee .text {\n        font-size: 14px; /* Adjust font size */\n        line-height: 20px; /* Adjust line height */\n        width: 100%; /* Ensure text takes full width */\n    }\n\n    .why-votesee .lorem-ipsum-dolor {\n        font-size: 12px; /* Adjust font size for very small screens */\n        line-height: 18px; /* Adjust line height */\n    }\n\n    .why-votesee .button-instance {\n        padding: 8px 12px; /* Adjust padding for smaller screens */\n        width: auto; /* Ensure button width is determined by content */\n        align-self: flex-start; /* Keep the button aligned to the left */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
